import { Component, Mixins, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { Debounce } from 'lodash-decorators'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import AddButton from '@/_components/button/add/add.vue'
import Languages from '@/views/Language/components/languages/languages.vue'
import StringGroup from '@/views/Language/components/stringGroup/stringGroup.vue'
import String from '@/views/Language/components/string/string.vue'
import Tags from '@/views/Language/components/tags/tags.vue'

import StringGroupModel from '@/views/Language/models/stringGroup'
import TranslationModel from '@/views/Language/models/translation'
import LanguageModel from '@/views/Language/models/language'
import TagModel from '@/views/Language/models/tag'
import StringModel from '@/views/Language/models/string'

@Component({
    components: { ToolbarComponent, AddButton, Languages, StringGroup, String, Tags },
})
export default class Dashboard extends Mixins<MixinInterface>() {
    loading = true
    infiniteID = new Date()

    offset = 0

    get searchTerm() {
        return this.$store.getters.stringGroupSearchTerm
    }

    @Debounce(200)
    set searchTerm(str: string) {
        this.$store.commit('stringGroupSearchTerm', str)
    }

    get searchTags() {
        return this.$store.getters.stringGroupTags
    }

    @Debounce(200)
    set searchTags(tags: Array<string>) {
        this.$store.commit('stringGroupTags', tags)
    }

    handleTagCreated(tag: TagModel) {
        if (tag._id) this.searchTags = [...this.searchTags, tag._id]
    }

    get token() {
        return this.$route.params.token
    }

    get hasAccess() {
        return this.token || this.isSuperuser
    }

    get tags(): Array<TagModel> {
        return this.$store.getters.tags
    }

    stringGroups: Array<StringGroupModel> = []
    strings: Array<StringModel> = []

    get stringGroupsSorted() {
        return this.stringGroups.filter((stringGroup) =>
            this.searchTerm
                ? stringGroup.name
                      .toString()
                      .toLowerCase()
                      .includes(this.searchTerm.toString().toLowerCase())
                : stringGroup
        )
    }

    @Debounce(500)
    @Watch('searchTerm')
    initiatehandler() {
        this.offset = 0
        this.strings = []
        this.infiniteID = new Date()
    }

    async searchTranslations($state: any) {
        if (this.isSuperuser && this.searchTerm && this.searchTerm.length > 1) {
            let filters = {
                'filter[searchTerm]': this.searchTerm,
                'page[offset]': this.offset,
                'page[limit]': TranslationModel.limit,
            }

            let res = await TranslationModel.search(filters)
            if (res) {
                this.strings.push(...res.strings)
                this.strings = this.lodash.uniqBy(this.strings, '_id')
                this.offset = this.offset + TranslationModel.limit

                if (res.length == TranslationModel.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
            } else {
                $state.complete()
            }
        } else {
            $state.complete()
        }
    }

    async initPost() {
        await StringGroupModel.initPost(null, this.stringGroups)
        this.stringGroups = await StringGroupModel.getAllStringGroups(this.token)
    }

    created() {
        this.$store.commit('stringGroupSearchTerm', '')
    }

    async mounted() {
        this.loading = true
        this.stringGroups = await StringGroupModel.getAllStringGroups(this.token)
        this.loading = false
    }

    async reload() {
        this.loading = true
        let languages = await LanguageModel.getAllTranslationLanguages()
        this.$store.commit('translationLanguages', languages)
        let tags = await TagModel.getAllTags(this.token)
        this.$store.commit('tags', tags)
        this.stringGroups = await StringGroupModel.getAllStringGroups(this.token)
        this.loading = false
    }
}
